<div class="viewbg">
  <div style="padding: 5px 20px 20px 20px">
    <span class="span" (click)="saveEdit()">
      <svg
        t="1619677921293"
        class="icon"
        viewBox="0 0 1204 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="18472"
        width="16"
        height="17"
        style="vertical-align: middle; margin-right: 6px; margin-bottom: 1px"
      >
        <path
          d="M0.002 541.857471c0-124.482878 85.639916-233.859772 200.041805-266.24674C263.378743 115.141888 420.24759 0 603.74741 0c184.937819 0 337.48767 115.142888 400.800609 275.610731 118.023885 33.102968 200.052805 141.046862 200.052805 266.24774 0 153.99785-124.494878 279.244727-282.069725 279.244727-29.502971 0-56.135945-26.619974-56.135945-56.111945 0-33.831967 26.619974-56.135945 56.136945-56.135945 94.978907 0 170.572833-74.110928 170.572834-166.938837 0-49.653952-22.350978-95.709907-59.006943-125.211878l-10.06999-9.409991c-2.881997-3.599996-7.199993-6.469994-12.939987-10.06999-2.893997-3.612996-9.409991-3.612996-12.939988-6.482994h-3.599996c-2.881997-3.599996-6.481994-3.599996-9.409991-6.469993h-3.599997c-2.882997 0-6.481994-3.609996-10.08199-3.609997-2.881997 0-6.469994 0-6.469993-2.869997h-9.409991c-3.599996 0-6.469994 0-10.08199-3.599996h-26.561974c-2.881997-10.787989-6.481994-18.704982-6.481994-29.503972-2.869997 0-2.869997-3.587996-2.869997-6.469993-3.587996-6.481994-3.587996-12.939987-6.469994-19.433981 0-3.599996-3.611996-3.599996-3.611996-7.187993-2.869997-6.469994-6.469994-12.939987-10.057991-19.420981v-6.481994c-2.893997-6.469994-9.409991-12.939987-12.939987-19.433981-55.395946-92.15591-157.608846-154.715849-272.763734-154.715849-118.012885 0-220.181785 62.559939-275.58773 154.715849l-9.409991 19.433981c0 2.163998-1.447999 2.163998-2.153998 4.316996l-1.446999 2.164998-10.08099 19.419981v7.199993l-9.339991 19.434981v6.445993c-3.611996 10.799989-7.199993 18.715982-7.199993 29.502972H259.049747c-2.869997 3.599996-6.469994 3.599996-9.339991 3.599996h-6.493994c-2.869997 2.163998-4.305996 2.869997-5.034995 2.869997a1.340999 1.340999 0 0 1-2.152997 0c-2.869997 0-6.481994 3.610996-9.409991 3.610997h-6.469994c-3.610996 2.881997-6.481994 2.881997-10.08199 6.469993h-3.586997c-2.869997 2.869997-6.481994 2.869997-9.41099 6.481994h-3.599997c-2.869997 3.599996-6.459994 6.469994-10.06999 10.06999-6.469994 2.869997-9.339991 6.481994-12.939987 9.409991-36.689964 29.503971-55.395946 75.559926-55.395946 125.212878 0 92.827909 75.558926 166.939837 166.939837 166.939837 33.829967 0 59.017942 22.349978 59.017942 56.135945 0 29.502971-25.186975 56.111945-59.019942 56.111945C128.097875 821.103198 0.002 695.85632 0.002 541.857471z m377.789631 187.042817c0-16.551984 6.469994-28.785972 12.939987-39.572961L561.293452 502.309509c10.799989-10.787989 25.879975-16.551984 42.466958-16.551983s29.503971 5.763994 43.172958 16.551983L813.871205 689.349327a54.971946 54.971946 0 0 1 16.550984 39.573961c0 29.502971-25.185975 55.418946-59.005942 55.418946-16.550984 0-28.785972-8.634992-39.584962-19.421981l-71.946929-78.452923v282.104724c0 33.819967-25.184975 55.418946-56.135946 55.418946-32.372968 0-55.418946-21.585979-55.418945-55.419946V686.50433l-71.89993 78.439923c-10.785989 10.787989-26.619974 19.421981-43.159958 19.421981-29.561971 0-55.477946-25.914975-55.477946-55.406946z"
          p-id="18473"
          fill="#5B6c74"
        ></path>
      </svg>
      保存
    </span>
    <a [routerLink]="['/scanner/materials']">
      <i
        nz-icon
        nzType="close"
        style="float: right; font-size: 16px"
        nzTheme="outline"
      ></i
    ></a>
  </div>
  <div style="padding-bottom: 20px">
    <ul
      nz-menu
      nzMode="horizontal"
      style="padding: 0px 40px; font-weight: 700; color: black"
    >
      总成零件
    </ul>
    <ul style="padding: 25px; background: #ffffff">
      <div nz-row nzGutter="16">
        <div nz-col nzSpan="10" class="gutter-row">
          <div>总成零件编码</div>
          <div style="margin-top: 10px; width: 80%">
            <nz-select
              nzMode="default"
              [(ngModel)]="selectedCode"
              nzPlaceHolder="选择或搜索更多"
              nzAllowClear
              nzShowSearch
              [nzServerSearch]="true"
              (nzOnSearch)="onSearch($event)"
              (nzScrollToBottom)="loadMore()"
              (ngModelChange)="modelChange($event)"
            >
              <nz-option *ngIf="displayTips" nzDisabled nzCustomContent>
                搜索
              </nz-option>
              <nz-option
                *ngFor="let o of optionList"
                [nzValue]="o.code"
                [nzLabel]="o.label"
              ></nz-option>
            </nz-select>
          </div>
        </div>
        <div nz-col nzSpan="10" class="gutter-row" style="margin-left: 20px">
          <div>总成零件名称</div>
          <div style="margin-top: 10px; width: 80%">
            <input nz-input [(ngModel)]="value" [disabled]="true" />
          </div>
        </div>
      </div>
    </ul>
  </div>
  <div>
    <!-- <app-add-table selectbox="true" #addtable></app-add-table> -->
    <app-table-add
      selectbox="true"
      [amendId]="amendId"
      #addtable
    ></app-table-add>
  </div>
</div>
